import { render } from "./DialogB.vue?vue&type=template&id=e281f802&scoped=true"
import script from "./DialogB.vue?vue&type=script&lang=js"
export * from "./DialogB.vue?vue&type=script&lang=js"

import "./DialogB.vue?vue&type=style&index=0&id=e281f802&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e281f802"]])

export default __exports__